import { render, staticRenderFns } from "./Costs.vue?vue&type=template&id=08414821&"
import script from "./Costs.vue?vue&type=script&lang=ts&"
export * from "./Costs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports